import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { PricingDetailModal } from './PricingDetailModal';
export function PricingDetail() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section className="bg-arena py-[48px] md:py-[64px]" data-id="element-196" data-mp="3h22x7py3m1ly">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-197" data-mp="3l0k90msgs09p">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-arena-dark border border-salvia/25 rounded-[12px] px-8 py-8 md:py-9 flex flex-col md:flex-row md:items-center md:justify-between gap-5 max-w-[760px] mx-auto" data-id="element-198" data-mp="37a6we74mnxe1">
          <p className="font-display text-[18px] md:text-[20px] font-semibold text-carbon" data-id="element-199" data-mp="2obkz73c8eqfe">
            ¿Necesitas conocer el detalle de Sistema Completo?
          </p>
          <button onClick={() => setIsModalOpen(true)} className="inline-flex items-center justify-center gap-1.5 bg-verde text-arena font-display font-semibold text-[14px] px-6 py-3.5 rounded-[6px] hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta transition-all duration-200 flex-shrink-0" data-id="element-200" data-mp="2tcib4y6neo8g">
            Ver alcance detallado <ArrowRight size={15} data-id="element-201" data-mp="1hzbsk67wppv1" />
          </button>
        </motion.div>
      </div>

      <PricingDetailModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-202" data-mp="u7o4rx5xyuwz" />
    </section>;
}